// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"Video_videoWrapper__2TgBg","videoContentWrap":"Video_videoContentWrap__2D-jn"};